export const COLORS = {
  primary: '#3498db',
  primaryDark: '#2980b9',
  lightGray: '#f5f5f5',
  darkGray: '#333333',
  cyan: '#4ecdc4',
  white: '#ffffff',
  black: '#000000',
} as const;
